import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ColaboradorCadastro } from '../models/colaborador-cadastro';
import { ColaboradorCadastroArquivo } from '../models/colaborador-cadastro-arquivo';
import { Colaborador, CollaboratorAddress } from '../models/colaborador';
import { CollaboratorFilter } from './../models/collaborator-filter';
import { CollaboratorPaged } from './../models/collaborator-paged';
import { ColaboradoresId } from './../models/colaborador-ids';
import { Collaborator, CollaboratorAccounts, CollaboratorFiltered } from '../models/collaborator';
import { Observable, BehaviorSubject } from 'rxjs';
import { ResponseBase } from '../models/response-base';
import { CollaboratorDetailsModel } from '../models/CollaboratorDetailsModel';
import { ColaboradorPaged } from '../models/colaborador-paged';
import { ColaboradorFilterOptions } from '../shared/helpers/models/colaborador-filter-options';
import { LocalStoreKeys } from '../shared/helpers/localstorage/local-store';
import { CollaboratorWithoutGroupRequestModel } from '../models/request/collaborator-without-group';
import { CollaboratorGroupPaged } from '../models/group';
import { BeneficioColaborador, BeneficioGrupo } from '../models/beneficio-colaborador';
import { AuthenticationService } from './authentication.service';
import { SuspendColllaboratorRequestModel } from '../models/request/suspend-collaborator-request';
import { CreateCollaboratorBatch } from '../models/colaborador-batch';

@Injectable({
    providedIn: 'root'
})
export class ColaboradorService {

    API: string = environment.API + 'Portal/colaboradores';
    private URL = environment.GATEWAY + 'collaborator';

    private colaboradoresArquivoListSubject: BehaviorSubject<ColaboradoresId[]>;
    public colaboradoresArquivoList: Observable<ColaboradoresId[]>;
    private data = this.authenticationService.currentUserValue;

  private getHeaders() {
    const headers: any = new HttpHeaders({"Content-Type": "application/json",'Authorization': 'Bearer ' + this.data.token.accessToken});
    return headers;
  }

    constructor(private http: HttpClient, private authenticationService: AuthenticationService) {
        this.colaboradoresArquivoListSubject = new BehaviorSubject<ColaboradoresId[]>(JSON.parse(localStorage.getItem(LocalStoreKeys.colaboradoesArquivoList)));
        this.colaboradoresArquivoList = this.colaboradoresArquivoListSubject.asObservable();
    }

    setCurrentCollaboratorIds(newList: ColaboradoresId[]) {
        localStorage.setItem(LocalStoreKeys.colaboradoesArquivoList, JSON.stringify(newList));
        this.colaboradoresArquivoListSubject.next(newList);
    }

    add(colaborador: ColaboradorCadastro, cedenteGuid: string, gestorGuid: string): Observable<ResponseBase<Colaborador>> {
        colaborador.cedenteGuid = cedenteGuid
        colaborador.gestorGuid = gestorGuid
        colaborador.cedenteId = parseInt(sessionStorage.getItem('cedenteId'));
        return this.http.post<ResponseBase<Colaborador>>(`${this.URL}/create`, colaborador);
    }

    addArquivo(colaboradores: ColaboradorCadastroArquivo, cedenteGuid: string, gestorGuid: string): Observable<ResponseBase<any>> {
        return this.http.post<ResponseBase<ColaboradoresId[]>>(`${this.API}/arquivo/${gestorGuid}/cedente/${cedenteGuid}`, colaboradores);
    }

    addLote(colaboradores: ColaboradorCadastro[], cedenteGuid: string, gestorGuid: string): Observable<ResponseBase<any>> {
        return this.http.post<ResponseBase<any>>(`${this.API}/cedentes/${cedenteGuid}/gestores/${gestorGuid}/lote`, colaboradores);
    }

    getAllPagedGateway(assignorGuid: string, offset: number, limit: number, object: CollaboratorFilter, filters: ColaboradorFilterOptions): Observable<ResponseBase<CollaboratorPaged>> {
        let headers = new HttpHeaders();
        headers = headers.append('Gateway', 'true');

        let params = new HttpParams();

        // parametros
        params = params.append('hasApp', filters.aplicativo.toString());
        params = params.append('allowSearchByName', filters.permitirBuscarNome.toString());
        params = params.append('allowSearchByDocument', filters.permitirBuscarCPF.toString());
        params = params.append('allowSearchByNameLike', filters.permitirBuscarNomeLike.toString());
        params = params.append('allowSearchByDocumentLike', filters.permitirBuscarCPFLike.toString());
        params = params.append('allowEmptySearch', filters.permitirBuscarVazio.toString());

        return this.http.post<ResponseBase<CollaboratorPaged>>(`${this.URL}/${assignorGuid}/page/${offset}/limit/${limit}`, object, { headers, params });
    }

    enable(collaboratorId: number, assignorGuid: string, managerGuid: string, justivicativa: string): Observable<ResponseBase<Colaborador>> {
        let headers = new HttpHeaders();
        headers = this.getHeaders();

        return this.http.put<ResponseBase<Colaborador>>(`${this.URL}/enable/${collaboratorId}/assignor/${assignorGuid}/manager/${managerGuid}`, justivicativa, {headers});
    }

    disable(collaboratorId: number, assignorGuid: string, managerGuid: string, justivicativa: string): Observable<ResponseBase<Colaborador>> {
        let headers = new HttpHeaders();
        headers = this.getHeaders();

        const options = {
            headers,
            body: justivicativa
        };
        return this.http.delete<ResponseBase<Colaborador>>(`${this.URL}/disable/${collaboratorId}/assignor/${assignorGuid}/manager/${managerGuid}`, options);
    }

    suspend(suspendRequest: SuspendColllaboratorRequestModel): Observable<ResponseBase<Colaborador>> {
        let headers = new HttpHeaders();
        headers = this.getHeaders();

        const options = {
            headers,
            body: suspendRequest
        };
        return this.http.delete<ResponseBase<Colaborador>>(`${this.URL}/suspend`, options);
    }

    getCollaboratorFilter(assignorGuid: string, q: string): Observable<ResponseBase<CollaboratorFiltered[]>> {
        let headers = new HttpHeaders();
        headers = headers.append('no-loader', 'true');

        let params = new HttpParams();
        params = params.append('q', q);
        return this.http.get<ResponseBase<CollaboratorFiltered[]>>(`${this.URL}/assignor/${assignorGuid}/filter`, {headers, params});
    }

    // delete(colaboradorId: number, cedenteGuid: string, gestorGuid: string): Observable<ResponseBase<Colaborador>> {
    //     return this.http.delete<ResponseBase<Colaborador>>(`${this.API}/${colaboradorId}/cedentes/${cedenteGuid}/gestores/${gestorGuid}`);
    // }

    update(colaboradorId: number, colaborador: ColaboradorCadastro, cedenteGuid: string, gestorGuid: string): Observable<ResponseBase<Colaborador>> {
        colaborador.colaboradorId = colaboradorId
        colaborador.cedenteGuid = cedenteGuid
        colaborador.gestorGuid = gestorGuid
        colaborador.cedenteId = parseInt(sessionStorage.getItem('cedenteId'));
        return this.http.put<ResponseBase<Colaborador>>(`${this.URL}/update`, colaborador);
    }

    getById(colaboradorId: number, cedenteGuid: string): Observable<ResponseBase<Colaborador>> {
        return this.http.get<ResponseBase<Colaborador>>(`${this.API}/${colaboradorId}/cedentes/${cedenteGuid}`);
    }



    // getColaboradoresPedido(produtoGuid: string, cedenteGuid: string): Observable<ResponseBase<Colaborador[]>> {

    //     return this.http.get<ResponseBase<Colaborador[]>>(`${this.API}/produtos/${produtoGuid}/cedentes/${cedenteGuid}`);
    // }

    GetDetails(personGuid: string, assignorGuid: string, gestorGuid?: string): Observable<ResponseBase<CollaboratorDetailsModel>> {
        let params = new HttpParams();

        params = params.append('gestorGuid', gestorGuid);
        return this.http.get<ResponseBase<CollaboratorDetailsModel>>(`${this.API}/${personGuid}/cedente/${assignorGuid}`, { params });
    }

    postColaboradoresPedido(assignorGuid: string, offset: number, limit: number, object: CollaboratorFilter):  Observable<ResponseBase<CollaboratorPaged>> {
        let headers = new HttpHeaders();
        headers = headers.append('Gateway', 'true');
        return this.http.post<ResponseBase<CollaboratorPaged>>(`${this.URL}/products/${assignorGuid}/page/${offset}/limit/${limit}`, object, { headers });
    }


    getCollaboratorsWithoutGroup(collaborators: CollaboratorWithoutGroupRequestModel, object: CollaboratorFilter, filters: ColaboradorFilterOptions) {
        let headers = new HttpHeaders();
        headers = headers.append('Gateway', 'true');

        let params = new HttpParams();
        // parametros
        params = params.append('hasApp', filters.aplicativo.toString());
        params = params.append('allowSearchByName', filters.permitirBuscarNome.toString());
        params = params.append('allowSearchByDocument', filters.permitirBuscarCPF.toString());
        params = params.append('allowSearchByNameLike', filters.permitirBuscarNomeLike.toString());
        params = params.append('allowSearchByDocumentLike', filters.permitirBuscarCPFLike.toString());
        params = params.append('allowEmptySearch', filters.permitirBuscarVazio.toString());

        return this.http.post<ResponseBase<CollaboratorGroupPaged>>(`${this.URL}/${collaborators.assignorGuid}/without-group/page/${collaborators.page}/limit/${collaborators.limit}`, object, { headers, params});
    }

    getBeneficiosFromColaborador(cedenteGuid: string, colaboradorId: number) {
        let headers = new HttpHeaders();
        headers = headers.append('Gateway', 'true');
        return this.http.get<ResponseBase<BeneficioGrupo[]>>(
            `${this.URL}/cedente/${cedenteGuid}/colaborador/${colaboradorId}/beneficios`, { headers }
        );
    }

    getContasColaborador(cedenteGuid: string, colaboradorId: number):  Observable<ResponseBase<CollaboratorAccounts>> {
        let headers = new HttpHeaders();
        headers = headers.append('Gateway', 'true');
        return this.http.get<ResponseBase<CollaboratorAccounts>>(`${this.URL}/account/${colaboradorId}/assignor/${cedenteGuid}`, { headers });
    }

    getTotalCollaborators(assignorGuid: string): Observable<ResponseBase<number>> {
        let params = new HttpParams();
        params = params.append('assignorGuid', assignorGuid);
        return this.http.get<ResponseBase<number>>(`${this.URL}/count`, { params });
    }

    getCollaboratorAddress(collaboratorId: number, assignorGuid: string): Observable<ResponseBase<CollaboratorAddress>> {
        let params = new HttpParams();
        params = params.append('collaboratorId', collaboratorId.toString());
        params = params.append('assignorGuid', assignorGuid);
        return this.http.get<ResponseBase<CollaboratorAddress>>(`${this.URL}/address`, { params });
    }

    createCollaboratorAddress(collaboratorId: number, assignorGuid: string, collaboratoAddress: CollaboratorAddress): Observable<ResponseBase<boolean>> {
        let params = new HttpParams();
        params = params.append('collaboratorId', collaboratorId.toString());
        params = params.append('assignorGuid', assignorGuid);
        return this.http.post<ResponseBase<boolean>>(`${this.URL}/address/create`, collaboratoAddress, { params });
    }

    updateCollaboratorAddress(collaboratorId: number, assignorGuid: string, collaboratoAddress: CollaboratorAddress): Observable<ResponseBase<boolean>> {
        let params = new HttpParams();
        params = params.append('collaboratorId', collaboratorId.toString());
        params = params.append('assignorGuid', assignorGuid);
        return this.http.put<ResponseBase<boolean>>(`${this.URL}/address/update`, collaboratoAddress, { params });
    }

    createCollaboratorBatch(collaborators: CreateCollaboratorBatch, managerGuid: string, assignorGuid: string, ): Observable<ResponseBase<number>> {
        return this.http.post<ResponseBase<number>>(`${this.URL}/create/batch/${managerGuid}/assignor/${assignorGuid}`, collaborators);
    }

    getStatusBatch(batchId: number, assignorGuid: string): Observable<ResponseBase<any>> {
        let headers = new HttpHeaders();
        headers = headers.append('no-loader', 'true');
        return this.http.get<ResponseBase<any>>(`${this.URL}/batch/status/${batchId}/assignor/${assignorGuid}`, { headers });
    }

    getBatchErrors(batchId: number, assignorGuid: string): Observable<ResponseBase<any>> {
        let headers = new HttpHeaders();
        return this.http.get<ResponseBase<any>>(`${this.URL}/batch/download/${batchId}/assignor/${assignorGuid}`, { headers });
    }

    getCollaboratorsBatch(batchId: number, assignorGuid: string): Observable<ResponseBase<ColaboradoresId[]>> {
        let headers = new HttpHeaders();
        return this.http.get<ResponseBase<ColaboradoresId[]>>(`${this.URL}/batch/${batchId}/assignor/${assignorGuid}`, { headers });
    }
}
